// Reine Logik fuer vom Nutzer eingegebene Links - ohne React, ohne Firebase.

/**
 * Ist das eine Adresse, die wir in ein href schreiben duerfen?
 *
 * Nur http und https. Ein "javascript:"-Link waere ausfuehrbarer Code im
 * Browser jedes Mitglieds - dieselbe Klasse Problem wie beim Profilbild im
 * techsoul-Projekt, wo avatarUrl deshalb nur echte Storage-URLs annimmt.
 * Die Rule in firestore.rules prueft dasselbe noch einmal serverseitig.
 */
export function isSafeHttpUrl(value) {
  if (typeof value !== 'string' || !value.trim()) return false;
  try {
    const { protocol } = new URL(value.trim());
    return protocol === 'http:' || protocol === 'https:';
  } catch {
    // Kein parsebarer URL - dann auch kein Link.
    return false;
  }
}

/**
 * Eingabe zu einer speicherbaren Adresse machen - oder zu null.
 *
 * "instagram.com/clubminithrills" ist das, was Leute tatsaechlich eintippen.
 * Ohne Schema wuerde daraus ein relativer Link, der im Browser auf der
 * eigenen Seite landet. Fehlt es, ergaenzen wir https:// statt die Eingabe
 * abzulehnen.
 */
export function normalizeLink(value) {
  const trimmed = (value ?? '').trim();
  if (!trimmed) return null;

  const withScheme = /^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(trimmed) ? trimmed : `https://${trimmed}`;
  return isSafeHttpUrl(withScheme) ? withScheme : null;
}

/**
 * Was am Link stehen soll: Host ohne "www.", ohne Schema.
 * Eine 200 Zeichen lange Ticket-URL als Linktext ist unlesbar.
 */
export function linkLabel(value) {
  if (!isSafeHttpUrl(value)) return '';
  try {
    return new URL(value.trim()).host.replace(/^www\./, '');
  } catch {
    return '';
  }
}
